import React from "react";
import Button from "../includes/button";
import TeamPortrait from "./images/careers-hero.webp";

// Layout mirrors the About hero (src/about/hero.js): full-height band, p-24 at
// lg, inner container with a py-10 gutter, and the two columns vertically
// centred. text-left is required because .App sets text-align: center globally.
const CareersHero = () => {
    return (
        <div className="w-full flex flex-row lg:h-screen mx-auto mt-16 lg:mt-0 p-6 lg:p-24 gap-24 bg-careersHero">
            <div className="w-full h-full gap-10 lg:gap-20 flex lg:flex-row flex-col items-stretch py-10 container mx-auto">
                <div className="w-full lg:w-1/2 flex-1 text-left gap-6 flex flex-col items-start justify-center">
                    <h1 className="lg:text-[60px] md:text-5xl text-3xl font-bold leading-[1.08] tracking-[-0.6px] text-blue10">
                        Do your best work{" "}
                        <span className="font-normal italic text-primaryBrand">with people who care.</span>
                    </h1>
                    <p className="lg:text-xl text-base leading-[1.75] text-grey45">
                        Join a team of thoughtful operators, project leaders, and makers helping organizations move
                        important work forward. At PMG, partnership is how we work — with clients and with each other.
                    </p>
                    <div className="flex flex-wrap items-center gap-6 lg:gap-10 mt-2">
                        <Button
                            to="/careers#life-at-pmg"
                            label="Life at PMG"
                            variant="light-primary"
                            isHashLink={true}
                            className="md:!w-[200px]"
                        />
                    </div>
                </div>

                {/* Square frame so the image fills its column, as the design
                    intends. The portrait has ~580px of empty wall above the group,
                    so the crop is biased to 96% rather than centred: that trims the
                    dead ceiling instead of the feet, and leaves roughly 90px of
                    clearance above the heads and below the shoes. */}
                <div className="w-full lg:w-1/2 flex-1 h-auto lg:self-center aspect-square flex justify-center items-center">
                    <img
                        src={TeamPortrait}
                        alt="Members of the Partnered Management Group team talking together in the office"
                        width="800"
                        height="800"
                        loading="eager"
                        decoding="async"
                        className="w-full h-full object-cover object-[50%_96%] rounded-3xl"
                    />
                </div>
            </div>
        </div>
    );
};

export default CareersHero;
